

<template>
	<div>
		<compWrapper title="发货信息" theme="primary">
			<vFormItem label="平台销售订单号" label-width="120">
				<vInput v-model="formData.orderNo" readonly class="width-30per margin-top-15">
					<vIcon
						type="search"
						center
						slot="suffix"
						style="padding:6px;pointer-events: initial;"
						size="18"
						@click.native="handleOrderList"
					/>
				</vInput>
				<vCheckbox v-model="formData.isSplit" falseValue="0" trueValue="1">拆分包裹</vCheckbox>
				<span v-if="formData.isSplit==1" class="color-error">勾选拆分包裹，则系统将自动拆分成单个Seller SKU，单个数量去申请SFP面单。</span>
				<div class="color-error">说明：本测算调用亚马逊SFP运费测算接口，实际费用以账单为准。</div>
			</vFormItem>
			<footer class="text-center">
				<vButton class="margin-right-20" theme="primary" @click="submitCalculate">开始测算</vButton>
				<vButton @click="reset">重置</vButton>
			</footer>
		</compWrapper>
		<compWrapper title="运费测算结果" theme="info" :expand="false" v-if="calculateList.length">
			<header class="margin-left-30 margin-top-15">
				平台销售订单号:
				<span class="margin-right-20 font-bold">{{formData.orderNo}}</span>
				渠道账号:
				<span class="font-bold">{{formData.sourceChannel}}</span>
			</header>
			<compWrapper
				v-for="(item,index) in calculateList"
				class="margin-15"
				:key="index"
				:title="'包裹'+(index+1)"
			>
				<compPackagesize :data="item"></compPackagesize>
				<vTableSimple
					style="margin:0 15px;width:60%;display:inline-block;"
					:columns="carrierColumns"
					:data="handleSortCarrier(item.orderSurfaceCarrierList)"
					size="small"
					border
					stripe
				></vTableSimple>
				<vTableSimple
					style="margin:0 15px;width:30%;display:inline-block;"
					:columns="skuColumns"
					:data="handleSkuList(item)"
					size="small"
					border
					stripe
				></vTableSimple>
			</compWrapper>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpCalculateSfps, HttpSfpList } from "@/service/sfp/sfp";
import TableList from "@components/templates/tablelist";
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compPackagesize: () => import("./packagesize")
	},
	data() {
		return {
			loading: false,
			calculateList: [],
			formData: {
				orderNo: "",
				isSplit: "0"
			}
		};
	},
	computed: {
		...mapState("boss", ["accounts"]),
		carrierColumns() {
			return [
				{
					title: "承运商",
					key: "carrierCode"
				},
				{
					title: "承运商服务",
					key: "carrierService"
				},
				{
					title: "预估运费（USD）",
					key: "estimateCost"
				}
			];
		},
		skuColumns() {
			return [
				{
					title: "ERP SKU",
					key: "erpSku"
				},
				{
					title: "Seller SKU",
					key: "sellerSku"
				},
				{
					title: "单包裹数量(Seller SKU数量)",
					key: "singlePackageQuantity"
				}
			];
		}
	},
	methods: {
		handleSkuList(data) {
			return data.skuList || [data]
		},
		handleSortCarrier(data = []) {
			return data.map(function (item) {
				return {
					...item,
					estimateCost: Number(item.estimateCost || 0).toFixed(2)
				}
			}).sort(function (pre, cur) {
				return pre.estimateCost - cur.estimateCost;
			})
		},
		handleOrderList() {
			const accounts = this.accounts.map(item => {
				const { id, title, flag } = item;
				return {
					value: id,
					label: title
				};
			});
			const attrs = {
				columns: [
					{
						title: "平台订单号",
						key: "orderNo",
						render(h, { row }) {
							return <div><div class="color-primary">{row.sfpOrderId}</div>{row.orderNo}</div>
						}
					},
					{
						title: "渠道账号",
						key: "sourceChannel",
						// render: (h, { row }) => {
						// 	const sourceChannel = row.sourceChannel;
						// 	return (
						// 		accounts.find(function (item) {
						// 			return sourceChannel == item.value;
						// 		}) || {}
						// 	).label;
						// }
					},
					{
						title: "操作",
						width: 120,
						align: "center",
						render: (h, { row }) => {
							return h(
								"vButton",
								{
									props: {
										theme: "primary"
									},
									nativeOn: {
										click: () => {
											this.formData = {
												...this.formData,
												...row
											};
											this.$VModal.destroy();
										}
									}
								},
								"选择"
							);
						}
					}
				],
				Searchs: {
					show: true,
					style: "border:none;",
					labelWidth: "auto",
					align: "left"
				},
				SearchsData: [
					{
						label: "平台订单号",
						tag: "vInput",
						key: "CN_orderNo",
						show: true
					},
					{
						label: "渠道账号",
						tag: "vSelect",
						key: "EQ_sourceChannel",
						options: accounts,
						show: true,
						props: {
							dropStyle: "width:auto;min-width:186px;",
							filterable: true,
						}
					}
				],
				ajaxRequest: HttpSfpList,
				interceptResponse(data, _this) {
					const obj = {};
					(data.content || []).forEach(function (item) {
						obj[item.sfpOrderId] = item;
					});
					this.dataList = Object.values(obj);
				}
			};
			this.$VModal.default({
				title: "请选择平台销售订单",
				width: 1000,
				showFooter: false,
				render: (h, props) => {
					return this.$createElement(TableList, { attrs });
				}
			});
		},
		reset() {
			this.formData = {
				orderNo: "",
				isSplit: "1"
			}
			this.calculateList = [];
		},
		submitCalculate() {
			const { sfpOrderId, isSplit } = this.formData;
			if (!sfpOrderId) return;
			this.loading = true;
			HttpCalculateSfps({
				orderId: sfpOrderId,
				isSplit
			}).then(
				res => {
					this.calculateList = res.data;
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.calculateList = [];
					this.$VMessage.error({
						content: err.message,
						duration: 0
					});
				}
			);
		}
	}
};
</script>

